<!-- Migrated from legacy/Plus/Plus/Challenge/index.shtml (2017 archive) -->

<template>
  <p>
    <em>
      This is the archived call for entries for the 2017 VizbiPlus Creative Challenge.
      Submissions were open from 1 March to 19 May 2017; selected works were exhibited at the
      Spunky Bruiser Store in Darlinghurst from 29 May, and the awards were presented at Vivid
      Ideas on 12 June 2017.
    </em>
  </p>
  <h4>The VizbiPlus 2017 Creative Challenge: Call for Entries</h4>
  <img
    class="tall left"
    src="/Plus/img/350by600_tall.png"
    alt="VizbiPlus Exhibit image" />
  <p>
    Feeling artistic? Do you feel like taking part in an event that brings together international
    artists and scientists, an event that is also part of the world's largest festival of light?
    Fancy seeing your work featured throughout Vivid in the gallery space of the Spunky Bruiser,
    Darlinghurst? Care for the opportunity to meet some of the giants of science-based art, and
    to take part in a competition judged by Emmy and BAFTA award winner Drew Berry and Head of
    Curatorial at the Museum of Applied Arts &amp; Sciences Jacqui Strecker? Wanna win a Cintiq
    13HD as first prize?!
  </p>
  <p>
    Come on and join the VizbiPlus Challenge! Competition entry is free and open to all,
    including junior participants.
  </p>
  <p><strong>Judges prize:</strong></p>
  <ul>
    <li>
      one <strong>Wacom Cintiq 13HD</strong> valued at AUD $1,199, sponsored by the
      <a href="https://www.garvan.org.au/support/about-garvan-research-foundation">Garvan
        Research Foundation</a>
    </li>
    <li>
      opportunity for a solo exhibition in the Spunky Bruiser Store along with collaborative
      garment design and making with Spunky Bruiser to complement and be available for sale at
      the solo exhibition. Profits from collab garments will be split and artworks featured in
      the solo exhibition sold commission free.
    </li>
    <li>
      Junior Prize &mdash; mentoring workshops at Spunky Bruiser Store to design and make a small
      run of tees to be featured and sold in Spunky Bruiser Store with profits split with the
      winning artist
    </li>
  </ul>
  <p><strong>Key dates</strong></p>
  <ul>
    <li>Challenge Submission Opening date: 1st March 2017</li>
    <li>
      Challenge Submission Closing date: 19th of May 2017, 23:59 Australian Eastern Time Zone
      (UTC+10:00)
    </li>
    <li>Finalists Notified by: 22nd of May 2017</li>
    <li>
      Exhibit Opening Event &mdash; VizbiPlus Exhibit: A Showcase of Science-Inspired Artwork,
      29th May 2017, 6pm to 8pm
    </li>
    <li>
      Award Ceremony during VizbiPlus: Bridging Science with Art, Design &amp; Animation, 12th
      June 2017 from 5pm to 7pm
    </li>
  </ul>
  <h4>How to enter the competition</h4>
  <p class="step"><strong>Step 1</strong></p>
  <p>
    Watch and be inspired by the videos below. Check out the other assets shared by the artists
    too; they include images, models and scientific information about the videos.
  </p>
  <div class="videos">
    <div class="video">
      <p><strong>Rust: The Fungi that Destroy Plants</strong><br />from Chris Hammang</p>
      <div class="videoWrapper">
        <iframe
          src="https://www.youtube.com/embed/dFrDX1QkL7Q"
          title="Rust: The Fungi that Destroy Plants"
          frameborder="0"
          allowfullscreen />
      </div>
      <p>Download the animation assets <a href="/Plus/Assets/Rust.zip">here</a>.</p>
    </div>
    <div class="video">
      <p><strong>Cutting Cancer Loose</strong><br />from Kate Patterson</p>
      <div class="videoWrapper">
        <iframe
          src="https://www.youtube.com/embed/AnJXrlN40PU"
          title="Cutting Cancer Loose"
          frameborder="0"
          allowfullscreen />
      </div>
      <p>
        Download the animation assets <a href="/Plus/Assets/Cutting_Cancer_Loose.zip">here</a>.
      </p>
    </div>
  </div>
  <p class="step"><strong>Step 2</strong></p>
  <p>
    Create one piece of art or create many pieces of art! Work alone or as a team. Entries can be
    anything: a sculpture, a painting, a movie or an image. However, in order to make the judging
    process fair between different media, every artwork (including sculpture and movies) will be
    judged based on ONLY a digital picture that you'll submit (see Step 3). This shouldn't stop
    you creating non-digital work or work in your favourite medium.
  </p>
  <p>The gallery space has the following requirements for 2D and 3D artworks:</p>
  <ul>
    <li>2D artworks &mdash; no bigger than 1200mm x 800mm (including framing &mdash; framing is
      not a requirement)</li>
    <li>3D artworks &mdash; maximum base 450mm x 450mm, maximum height 800mm</li>
    <li>
      3D artworks should be made well and be able to withstand transportation and handling. They
      must also be stand alone or already attached securely to a stand. Artworks must not be top
      heavy and must sit solidly on either a stand or base of the artwork.
    </li>
    <li>
      All medium applied to the works must be dry before presenting them and no unsafe materials
      such as broken glass, sharp metals, sharp wires or toxic mediums are to be used in
      competition entry artworks.
    </li>
  </ul>
  <p class="step"><strong>Step 3</strong></p>
  <p>
    Submit a picture of your artwork. If you created multiple pieces, make sure you submit
    multiple entries. <strong>Please remember:</strong> your work will be judged based ONLY on
    the submitted picture. Remember to take that into account when creating the picture, and
    make it memorable! To complete the submission you will need to include a short description of
    your work (max. 300 words) that includes:
  </p>
  <ul>
    <li>Contributors (nominate one main contributor with contact details)</li>
    <li>Medium / methods used to create the artwork</li>
    <li>Brief description of the artwork.</li>
  </ul>
  <p>
    <strong>Entry format:</strong> still image of 16:9 aspect ratio (landscape), PNG format,
    min. 1920 x 1080 pixels, max. file size: 20 MB. Note: still images can be a screenshot of a
    video or an art piece you have created, but again the judges will base their evaluation on
    the submitted image.
  </p>
  <p>
    All artwork provided must be of family friendly nature, not be of a violent nature, does not
    incite violence and be for general exhibition i.e. suitable for everyone to watch including
    children without supervision.
  </p>
  <p>
    By submitting you will certify that the <strong>submitted material does not infringe anyone
      else's copyright</strong>. The entrant retains the copyright of all artworks submitted as
    competition entries. Also, selected artwork submitted as competition entries will be
    exhibited at the Spunky Bruiser (Darlinghurst, Sydney) and displayed on the VizbiPlus
    website and, if chosen as finalists, shown at the Vivid Ideas event on 12 June 2017 at the
    Vivid Ideas Exchange MCA. <strong>The entrant grants the VizbiPlus Team use of the artwork in
      the promotion of future competitions</strong> (e.g. posters, web pages, blog posts, and
    posts to social media).
  </p>
  <p class="step"><strong>Step 4</strong></p>
  <p>
    All submitted pieces will undergo a first-round selection. The following
    <strong>selection criteria</strong> apply: impactful communication, communication of
    scientific concepts through artistic expression, strength of aesthetic and conceptual
    quality, creativity. All artists selected to exhibit will be responsible for the delivery
    and collection of the artworks to and from The Spunky Bruiser Store on dates specified
    &mdash; all artworks must be clearly labelled with full name and contact details.
  </p>
  <p class="step"><strong>Step 5</strong></p>
  <p>
    The gallery space will have an exhibition opening as a free Vivid event on the 29 May 2017.
    Enjoy the show and meet the other artists.
  </p>
  <p class="step"><strong>Step 6</strong></p>
  <p>
    If your artwork is selected for the finals, you'll receive an invitation and a free ticket
    to the award ceremony on the 12 June 2017 at the Vivid Ideas Exchange at the Museum of
    Contemporary Art, Sydney (travel and accommodation costs not included). The ceremony
    constitutes part of a bigger event, namely VizbiPlus: Bridging Science with Art, Design
    &amp; Animation, which will feature a keynote talk and artwork from Drew Berry, an award
    winning scientific animator. <strong>Please note:</strong> to be in contention for the major
    prize <strong>you will need to be present</strong> at the final-round selection/award
    ceremony. For teams, at least one designated team member must be present.
  </p>
  <p><strong>Judges</strong></p>
  <ul>
    <li>
      <a href="https://www.wehi.edu.au/people/drew-berry">Drew Berry</a> Biomedical Animations
      Manager, WEHI Melbourne
    </li>
    <li>
      <a href="https://www.uts.edu.au/staff/deborah.szapiro">Deborah Szapiro</a> Lecturer, School
      of Design, UTS Sydney
    </li>
    <li>
      <a href="http://chrishammang.com.au/">Christopher Hammang</a> Biomedical Animator, Garvan
      Institute of Medical Research Sydney
    </li>
  </ul>
  <h4>Questions?</h4>
  <p>Get in touch with us at <Email to="vizbi-contact" />.</p>
</template>

<script setup>
import Email from "@/components/Email";
</script>

<style scoped>
h4 {
  clear: both; /* below the floated image */
}
p.step {
  color: var(--subtitle-color);
}
img.tall {
  max-width: 35%;
  border-radius: 4px;
}
img.left {
  float: left;
  margin: 0 1.5rem 1rem 0;
}
ul {
  list-style-type: square;
}
.videos {
  display: flex;
  flex-wrap: wrap;
  gap: 5%;
  clear: both;
}
.video {
  width: 45%;
  min-width: 260px;
  text-align: center;
}
.videoWrapper {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
